import { render, staticRenderFns } from "./ntDefaultValue-editor.vue?vue&type=template&id=56a2de88&scoped=true&"
import script from "./ntDefaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./ntDefaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2de88",
  null
  
)

export default component.exports